const clickableContainer = () => {
    const programGrid = document.querySelector('.fndry-programs__grid-row');
    
    if(programGrid){
        const programs = programGrid.querySelectorAll('.fndry-programs__grid-row > .fndry-col')
        
        programs.forEach((program) => {
            program.addEventListener('click', (e) => {
              if (!e.target.closest('a')) {
                const link = program.querySelector('a');
                if (link) link.click();
              }
            });
        });
    }

    const relatedPosts = document.querySelector('.fndry-post__related-posts');
    
    if(relatedPosts){
        const posts = relatedPosts.querySelectorAll('.fndry-post__related-post')
        console.log(posts);
        
        posts.forEach((post) => {
            post.addEventListener('click', (e) => {
              if (!e.target.closest('a')) {
                const link = post.querySelector('a');
                if (link) link.click();
              }
            });
        });
    }

}

export default clickableContainer;